import moment from 'moment'

export const generateCampaignName = ({ source, brandName, offer }) => {
  const date = moment().format('DDMMYYYY')
  const cleanSource = (source || '').toUpperCase().replace(/[\s_]/g, '')
  const cleanBrand = (brandName || '').toUpperCase().replace(/[\s_]/g, '')
  const cleanOffer = (offer || '').toUpperCase().replace(/[\s_]/g, '')

  return `ARC_${cleanSource}_${cleanBrand}_${cleanOffer}_${date}`
}

export const formatArcCampaignFromAPI = (campaign) => {
  if (!campaign) return null

  const { id, attributes = {}, relationships = {} } = campaign

  return {
    id,
    name: attributes.name,
    brandName: attributes.brand_name,
    offer: attributes.offer,
    source: attributes.source,
    active: attributes.active,
    startedAt: attributes.started_at,
    endAt: attributes.end_at,
    impressionCap: attributes.impression_cap,
    clickCap: attributes.click_cap,
    impressionsCount: attributes.impression_count || 0,
    clicksCount: attributes.click_count || 0,
    createdAt: attributes.created_at,
    updatedAt: attributes.updated_at,
    arcAdvertiserId: relationships.arc_advertiser?.data?.id,
    arcAdsIds: relationships.arc_ads?.data?.map(ad => ad.id) || [],
  }
}

export const formatArcCampaignForTable = (campaign, includedData = []) => {
  if (!campaign) return null

  const { id, attributes = {}, relationships = {} } = campaign

  const arcAdvertiser = includedData.find(
    item => item.type === 'arc_advertiser' && item.id === relationships.arc_advertiser?.data?.id
  )

  const impressionCount = attributes.impression_count || 0
  const clickCount = attributes.click_count || 0
  const impressionCap = attributes.impression_cap
  const clickCap = attributes.click_cap

  // Use server-provided remaining values if available, otherwise calculate
  const remainingImpressions = attributes.impressions_remaining !== undefined
    ? attributes.impressions_remaining
    : (impressionCap ? impressionCap - impressionCount : null)

  const remainingClicks = attributes.clicks_remaining !== undefined
    ? attributes.clicks_remaining
    : (clickCap ? clickCap - clickCount : null)

  return {
    id,
    key: id,
    name: attributes.name,
    brand_name: attributes.brand_name,
    offer: attributes.offer,
    source: attributes.source,
    active: attributes.active,
    started_at: attributes.started_at,
    end_at: attributes.end_at,
    impression_cap: impressionCap,
    click_cap: clickCap,
    impression_count: impressionCount,
    click_count: clickCount,
    created_at: attributes.created_at,
    updated_at: attributes.updated_at,
    arc_advertiser_id: relationships.arc_advertiser?.data?.id,
    arc_advertiser_name: arcAdvertiser?.attributes?.name || '-',
    remaining_impressions: remainingImpressions,
    remaining_clicks: remainingClicks,
  }
}

export const formatArcCampaignForAPI = (data) => {
  const attributes = {}

  // Only include fields that are present in the data object
  const nullableFields = ['end_at', 'impression_cap', 'click_cap']
  const fields = ['brand_name', 'offer', 'source', 'started_at', ...nullableFields]

  for (const field of fields) {
    if (data[field] !== undefined) {
      attributes[field] = nullableFields.includes(field)
        ? (data[field] != null ? data[field] : null)
        : data[field]
    }
  }

  const relationships = {}

  if (data.arc_advertiser_id) {
    relationships.arc_advertiser = {
      data: {
        type: 'arc_advertisers',
        id: data.arc_advertiser_id,
      }
    }
  }

  return {
    data: {
      type: 'arc_campaigns',
      attributes,
      relationships,
    }
  }
}

export const calculateActiveStatus = (campaign) => {
  if (!campaign) return false

  const now = moment()
  const startedAt = campaign.startedAt ? moment(campaign.startedAt) : null
  const endAt = campaign.endAt ? moment(campaign.endAt) : null

  if (startedAt && now.isBefore(startedAt)) {
    return false
  }

  if (endAt && now.isAfter(endAt)) {
    return false
  }

  if (campaign.impressionCap && campaign.impressionsCount >= campaign.impressionCap) {
    return false
  }

  if (campaign.clickCap && campaign.clicksCount >= campaign.clickCap) {
    return false
  }

  return true
}